'use strict';

var _ = require('lodash');

var ActionUtil = function ($injector) {
  
  function Action (definition) {
    Action.checkRequired(definition);
    this.setProperties(definition);
  }

  Action.Required = ['name', 'namespace', 'payload', 'purpose', 'dispatcherId'];
  
  Action.checkRequired = function (params) {
    _.forEach(Action.Required, function (key) {
      if (params[key] === undefined) {
        throw new Error('Missing required parameter: ' + key);
      }
    });
  };

  Action.getDispatcher = function (dispatcherId) {
    var Flux = $injector.get('sbFlux');
    var Dispatcher = Flux.Dispatcher;
    return Dispatcher.get(dispatcherId);
  };

  Action.prototype.getPayload = function () {
    var args = arguments;
    var payload = _.extend({}, this);
    
    // Assign keys listed in payload to class attributes by extracting the values
    // from the passed in arguments. Assumes that the order of the arguments is the
    // same as that registered to the $payload definition.
    _.forEach(this.$payload, function (attr, index) {
      payload[attr] = args[index];
    }.bind(this));

    return payload;
  };

  Action.prototype.setProperties = function (def) {
    // assign def to instance attributes, prepending $ to avoid possible 
    // collision with payload attrs
    _.forEach(def, function (val, key) {
      this['$' + key] = val;
    }.bind(this));
  };

  Action.prototype.dispatch = function () {
    var payload = this.getPayload.apply(this, arguments);
    var dispatcher = Action.getDispatcher(this.$dispatcherId);
    dispatcher.dispatch(payload);
  };

  Action.prototype.dispatchNext = function () {
    console.warn('DEPRECATED: Same as `dispatch` now');
    this.dispatch.apply(this, arguments);
  };

  return {
    create: function (namespace, dispatcherId, definition) {
      definition.namespace = namespace;
      definition.dispatcherId = dispatcherId;
      return new Action(definition);
    }
  };
};

ActionUtil.$inject = ['$injector'];
module.exports = ActionUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/lib/Action.js